export const AdjustAction = {
    ADD_INVENTORY: "add_inventory",
    MOVE_TO_UNAVAILABLE: "move_to_unavailable",
    MOVE_TO_AVAILABLE: "move_to_available",
    REMOVE_FROM_AVAILABLE: "remove_from_available",
    REMOVE_FROM_UNAVAILABLE: "remove_from_unavailable",
} as const;

export type AdjustAction = typeof AdjustAction[keyof typeof AdjustAction];

export const ACTION_LABELS: Record<AdjustAction, string> = {
    [AdjustAction.ADD_INVENTORY]: "Add Inventory",
    [AdjustAction.MOVE_TO_UNAVAILABLE]: "Move to Unavailable",
    [AdjustAction.MOVE_TO_AVAILABLE]: "Move to Available",
    [AdjustAction.REMOVE_FROM_AVAILABLE]: "Remove from Available",
    [AdjustAction.REMOVE_FROM_UNAVAILABLE]: "Remove from Unavailable",
};
